import script from "./StopPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StopPanel.vue?vue&type=script&setup=true&lang=js"

import "./StopPanel.vue?vue&type=style&index=0&id=bcaf595e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcaf595e"]])

export default __exports__